import * as Apis from '../../utils/apisRequest'


export default {

    //获取优惠券
    //https://apis.aigupiao.com/Coupon/term_list/?appversion=11.7.0&u_id=44324
    async Coupon(opt){
        return await Apis.get({
            url:'/Coupon/term_list/',
            params: {
                ...opt
            }
        })
    },

    // https://apis.aigupiao.com/UserCenter/my_buy_vip/?appversion=12.7.0&bundle_name=love_stock_pro&igptoken=ZmU4MDo6MjhmMDo1YzdjOjJmOTA6ZjJiYV8xNzY3MDU4OTA2XzE3NjcwNTgzMDZfZGRjZWU5OTQ1MTcwMDZmZjM2ZmJjZTY1MTFlNGM3YTc%3D&ip_city=%E8%81%94%E9%80%9A&ip_country=%E5%8C%97%E4%BA%AC&lgStatus=f3d74be5c0932d748d803e878d17ed47&love_stock_pro_is_show_all=1&mds=f3d74be5c0932d748d803e878d17ed47&origin_user_id=0&sign=4b7737305d8b74d080ed0cebe5f68022&source=ios&time=1767058306&type=all&u_id=805188&user_id=805188&vtoken=cb5283b76d4478b66f826b6faca4d67e
    async my_buy_vip(opt) {
        return await Apis.get({
            url: "/UserCenter/my_buy_vip",
            params: {
                ...opt
            }
        })
    }
}
